"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiDataSeriesMapSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var series_1 = require("../../utils/series");
var compute_series_domains_1 = require("./compute_series_domains");
exports.getSiDataSeriesMapSelector = re_reselect_1.default([compute_series_domains_1.computeSeriesDomainsSelector], function (_a) {
    var formattedDataSeries = _a.formattedDataSeries;
    return formattedDataSeries.reduce(function (acc, dataSeries) {
        var seriesKey = series_1.getSeriesKey(dataSeries, dataSeries.groupId);
        acc[seriesKey] = dataSeries;
        return acc;
    }, {});
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_si_dataseries_map.js.map